var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.875 4.554c0-1.48 1.2-2.679 2.679-2.679h.152a.8.8 0 0 1 .746.505l.66 1.651a1.07 1.07 0 0 1-.237 1.156l-.824.824a.51.51 0 0 0-.133.503 5.37 5.37 0 0 0 3.568 3.568.51.51 0 0 0 .503-.134l.824-.824a1.07 1.07 0 0 1 1.156-.237l1.65.66a.8.8 0 0 1 .506.747v.152c0 1.48-1.2 2.679-2.679 2.679h-.133a8.44 8.44 0 0 1-8.438-8.213v-.358Z"
  })));
};
export default SvgPhone;